import React, { useEffect, useState } from 'react';
import { Doughnut, defaults } from "react-chartjs-2";
import { Col } from "react-bootstrap";
import http from '../../services/httpService';
import './Chart.scss';
import { t } from 'react-switch-lang';


const Charts = ({ api, title }) => {
    const [data, setData] = useState({});
    const chart = () => {
        let labels = [];
        let values = [];
        let colors =[];
        let i = t('chart.titleFirstChart');
        http.get(api)
            .then(res => {
                Object.keys(res.data).map((item, index) => {
                    if(item === 'Nizak'){
                        return labels.push( t('chart.labels.low')) , values.push(res.data[item]) , colors.push('#37C35C');
                    } else if(item === 'Umjeren'){
                        return labels.push( t('chart.labels.moderate')) , values.push(res.data[item]) , colors.push('#FFBF00');
                    } else if(item === 'Visok'){
                        return labels.push(t('chart.labels.high'))  , values.push(res.data[item]) ,colors.push('#F59A1F');
                    }else if(item==='Veoma nizak') {
                        return labels.push( t('chart.labels.veryLow')) , values.push(res.data[item]) , colors.push('#027148');
                    } else if(item === 'Veoma visok') {
                        return labels.push( t('chart.labels.veryHigh')) , values.push(res.data[item]) , colors.push('#F5501F');
                    } else if(item === 'Otvoren'){
                        return labels.push( t('chart.labels.open')) , values.push(res.data[item]), colors.push('#37C35C');
                    } else if(item === 'Zatvoren'){
                        return labels.push(t('chart.labels.closed')) , values.push(res.data[item]),colors.push('#F5501F');
                    }   
                })
                setData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Rainfall',
                            backgroundColor: colors,
                            hoverBackgroundColor: colors,
                            data: values
                        }
                    ]
                })
            })
            .catch(err => {
               // console.log(err)
            });
           
    }
    useEffect(() => {
        chart();
    }, [])
    return (
        <Col md={3} sm={6}>
            <div className='dashboardChartCard'>
                <p className="dashboardChartCardTitle" >{title}</p>
                <Doughnut
                    data={data}
                    width={window.innerWidth > 1920 ? 'auto' : 220}
                    options={{
                        title: {
                            /* display: true,
                            text: title, */
                            fontSize: 12,
                            lineHeight: 1.33,
                            position: 'top',
                            align: 'start',
                        },
                        legend: {
                            display: true,
                            position: 'bottom',
                            align: 'center',
                            labels: {
                                fontFamily: 'AvenirNext-Regular',
                                fontSize: 12
                            }
                        },
                        elements: {
                            arc: {
                                borderWidth: 0
                            }
                        },
                        // responsive: true,
                        maintainAspectRatio: true,
                         layout: {
                            padding: {
                                bottom: 20
                            }
                        }  
                    }}
                />
            </div>
        </Col>
    );
};
export default Charts;